// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Heading-control-Heading-module__Heading";
export { _1 as "Heading" }
